<!--

-->
<!--
  대시보드 종합
  위젯 > 국가별 허용 트래픽 TOP

  @since: 2021-10-20
  @author: mk.ko
-->

<template>
  <div
    ref="chartWrapper"
    class="widget-wrapper"
  >

    <div :style="getContainerStyle">
      <!-- 세계 지도 -->
      <div :style="getWorldMapStyle">
        <world-map ref="worldMapComp"
                   :click="onClickCountryArea"
                   :mouseout="onOutCountryArea"
                   :mouseover="onOverCountryArea"
                   :mousemove="onMoveCountryArea"
                   :color-mapping-by-value="setColorMappingByValue"
        />
      </div>
      <!-- 데이터 테이블 -->
      <vue-table :data="geoCountryData"
                 :width="isMaximumWidget ? width*2 : width"
                 :height="height"
                 :columns="columns"
                 :sortable="false"
                 :selected.sync="selected"
                 :row-key="'geo'"
                 selection="single"
                 resize-mode="'overflow'">
        <template #body="props">
          <vue-table-tr :props="props" @onRowClick="onClickSelectCountry">
            <vue-table-td v-for="{field} of props.cols"
                          :key="field"
                          :props="props">
              <!-- 순서 -->
              <div v-if="field === 'seq'">
                <span :style="`color: ${getSequenceLabel(props)}`">● </span>
                {{ geoCountryData[props.row.__index].seq + 1 }}
              </div>

              <!-- 국가 코드 -->
              <div v-else-if="field === 'geo'" class="padL5">
                <span :class="`${getCountryFlagByCode(geoCountryData[props.row.__index].geo)}`" />
                {{ geoCountryData[props.row.__index].geo_name }}
              </div>

              <!-- Total -->
              <div v-else-if="field === 'total'" class="marR5">
                {{ byteConverter(geoCountryData[props.row.__index].total) }}
              </div>

              <!-- Input -->
              <div v-else-if="field === 'in'" class="marR5">
                {{ byteConverter(geoCountryData[props.row.__index].in) }}
              </div>

              <!-- Output -->
              <div v-else class="marR5">
                {{ byteConverter(geoCountryData[props.row.__index].out) }}
              </div>
            </vue-table-td>
          </vue-table-tr>
        </template>
      </vue-table>
    </div>

    <!-- 세계 지도 Tooltip -->
    <div ref="worldMapTooltip"
         class="countryinfo-tooltip"
         style="visibility: hidden; z-index: 1;">
      <p class="country-name">{{ selectName }}</p>
      <p class="country-all">{{ `${$t('cmn.all')} : ${ separateByComma(tooltipGeoData().total) }` }}</p>
      <p class="country-input">{{ `Inbound : ${ separateByComma(tooltipGeoData().in) }` }}</p>
      <p class="country-output">{{ `Outbound : ${ separateByComma(tooltipGeoData().out) }` }}</p>
    </div>
  </div>
</template>

<script>
  // 전역 이벤트버스 모듈
  import Bus from '~/plugins/event-hub'
  // Mixin 객체
  import {widgetMixin} from '~/mixins/widgetCommonMixin'
  // 스토어 헬퍼
  import {createNamespacedHelpers} from 'vuex'
  // 스토어 헬퍼 객체
  // const {mapGetters} = createNamespacedHelpers('common/common')
  const {mapActions} = createNamespacedHelpers('dashboard/dashboard')

  export default {
    name: 'widgetFwGeoAllowTrafficTopn',
    mixins: [widgetMixin],
    data () {
      return {
        isTooltipData: '',
        selected: {},
        // initMaximumData: false,
        w: 3,
        self: this,
        title: 'widgetFwGeoAllowTrafficTopn',
        haType: 'all',
        isLock: false,
        isMove: true,
        // isSync: true,
        isResize: false,
        deviceType: [20],
        restData: {
          result: [],
          unit_time: ''
        },
        isRefresh: true,
        eventBus: true,
        selectName: '',
        geoCountryData: [],
        saveSelection: null,
        height: 225,
        width: 350
      }
    },
    // mounted () {
    //   if (this.isMaximumWidget) {
    //     this.initMaximumData = true
    //   }
    // },
    computed: {
      /**
       * 이름: columns
       * 설명: 데이터 테이블 컬럼 목록을 리턴한다.
       */
      columns () {
        return [
          {
            name: 'seq',
            field: 'seq',
            label: this.$t('cmn.seq'),
            width: this.isMaximumWidget ? 50 : 100,
            align: 'center'
          },
          {
            name: 'geo',
            field: 'geo',
            label: this.$t('cmn.country'),
            width: 80,
            align: 'left'
            // format: (country = '') => this.getCountryInfo(country, 'name')
          },
          {
            name: 'total',
            field: 'total',
            label: this.$t('cmn.all'),
            align: 'right'
          },
          {
            name: 'in',
            field: 'in',
            align: 'right',
            label: 'Inbound'
            // title: 'Input'
            // cellRenderer: this.onRendererConvertorByte
          },
          {
            name: 'out',
            field: 'out',
            align: 'right',
            label: 'Outbound'
            // title: 'Output'
            // cellRenderer: this.onRendererConvertorByte
          }
        ]
      },
      getWorldMapStyle () {
        const style = {}

        style.width = this.isMaximumWidget ? 'calc(100% - 10px)' : `calc(100% - ${this.width}px)`
        style.height = this.isMaximumWidget ? `calc(100% - ${this.height}px)` : '100%'
        style.marginRight = this.isMaximumWidget ? '' : '10px'

        return style
      },
      getContainerStyle () {
        const style = {}

        style.width = '100%'
        style.height = this.isMaximumWidget ? '100%' : `${this.height}px` // '199px'
        style.display = 'flex'
        style.alignItems = 'center'
        style.flexDirection = this.isMaximumWidget ? 'column' : 'row'

        return style
      }
    },
    watch: {
      geoCountryData () {
        // 세계지도 컴포넌트 업데이트
        this.$refs.worldMapComp.changeWorldmapColor(this.setColorMappingByValue)
      }
    },
    methods: {
      ...mapActions([
        'getWidgetData'
      ]),
      onClickSelectCountry (rowItems) {
        const countryCode = rowItems.row.geo
        if (countryCode) {
          this.$refs.worldMapComp.selectCountryByCode(countryCode.toUpperCase())
        }
        this.selected = rowItems.row
      },
      /**
       * 이름: onOutCountryArea
       * 설명: 마우스가 지도를 벗어난 경우 스타일을 초기화하고 Tooltip을 숨긴다.
       */
      onOutCountryArea (self, event, data) {
        if (data.beforeStyle) {
          // Tooltip 엘리먼트 가져오기
          const tooltipEl = this.$refs.worldMapTooltip

          // Tip 숨김
          tooltipEl.style.visibility = 'hidden'

          // Tip 좌표 숨김
          // 확대 시 x축으로 빠르게 움직이면 좌표 값이 top : 0, left : 0으로 찍혀서 의도 하지 않은 위치에서 툴팁이 깜빡임
          if (this.isMaximumWidget && (data.properties.brk_name !== this.isTooltipData)) {
            tooltipEl.style.top = 0
            tooltipEl.style.left = 0
          }

          // Tooltip 스타일 변경
          self.style('fill', data.beforeStyle.fill)

          if (data.properties.iso_a2 !== this.selected.geo) {
            this.selected = {}
          }

          // 데이터 제거
          delete data.beforeStyle
        }
      },
      /**
       * 이름: onOverCountryArea
       * 마우스 Over시 Tooltip을 출력한다.
       */
      onOverCountryArea (self, event, data) {
        // Tooltip 엘리먼트 가져오기
        const tooltipEl = this.$refs.worldMapTooltip

        if (data.properties.iso_a2 !== this.selected.geo) {
          this.selected = {}
        }

        // 만약 클릭된 나라가 있으면 객체 초기화
        this.beforeSelectionInitStyle(tooltipEl)

        // Tooltip 스타일 반영
        this.applyTooltipStyle(self, data, tooltipEl)
      },
      /*
        이름: onClickCountryArea
        설명: 지도에 표시된 국가를 클릭하면 스타일과 정보 Tooltip을 화면에 출력한다.
      */
      onClickCountryArea (self, event, data) {
        // Detail이 Null이면 Custom Event (UIEvent가 아닌 경우 - 그리드 Row를 클릭하여 Dispatch를 발생 시킨 경우)
        if (!event.detail && !event.release) {
          // 국가 이름 맵핑
          this.selectName = data.properties.admin

          // 현재 마우스가 올라와 있는 국가
          this.selectCode = data.properties.iso_a2

          // Tooltip 엘리먼트
          const tooltipEl = this.$refs.worldMapTooltip

          // 다른나라 클릭시 스타일 제거
          this.beforeSelectionInitStyle(tooltipEl)

          // Tooltip 좌표 설정
          this.getTooltipCoordinate(event, data, tooltipEl)

          // Tooltip 스타일 반영
          this.applyTooltipStyle(self, data, tooltipEl)
          // Before click 객체에 DOM 데이터 입력
          this.saveSelection = {self, data}
        } else if (!event.detail && event.release) {
          // Tooltip 엘리먼트 가져오기
          const tooltipEl = this.$refs.worldMapTooltip

          // Tip 숨김
          tooltipEl.style.visibility = 'hidden'

          if (data.beforeStyle) {
            // Tooltip 스타일 변경
            self.style('fill', data.beforeStyle.fill)
          }

          // 데이터 제거
          delete data.beforeStyle
        }
        if (data.properties.iso_a2 !== this.selected.geo) {
          this.selected = {}
        }
      },
      /**
       * 이름: onMoveCountryArea
       * 설명: 마우스 Move시 발생하는 이벤트를 처리한다.
       */
      onMoveCountryArea (self, event, data) {
        // 국가 이름 맵핑
        this.selectName = data.properties.admin

        // 현재 마우스가 올라와 있는 국가
        this.selectCode = data.properties.iso_a2

        // 툴팁 요소 가져오기
        const tooltipEl = this.$refs.worldMapTooltip

        // SVG 엘리먼트 좌표 찾기
        this.getTooltipCoordinate(event, data, tooltipEl)
      },
      /**
       * 이름: getCountryInfo
       * 설명: 전달된 데이터에서 국가 코드만 추출하여 리턴한다.
       */
      // getCountryInfo (info = '', target = 'code') {
      //   return info ? info.split('|')[target === 'code' ? 1 : 0] : ''
      // },
      /**
       * 이름: getSequenceLabel
       * 설명: 데이터 순위를 색상별로 출력한다.
       */
      getSequenceLabel ({row}) {
        const targetCount = this.geoCountryData[row.__index].total
        const divisionCount = this.geoCountryData[0].total / 5

        return this.getGeoFillColorByCount(divisionCount, targetCount)
      },
      /**
       * 이름: getCountryFlagByCode
       * 설명: 국가 코드에 해당되는 국기와 국가명을 출력한다.
       */
      getCountryFlagByCode (code) {
        const isNoneFlag = ['A0', 'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'C0', 'D0'].indexOf(code.toUpperCase()) > -1
        return isNoneFlag ? 'flag-icon flag-icon-none' : `flag-icon flag-icon-${code.toLowerCase()}`
      },
      /**
       * 이름: beforeSelectionInitStyle
       * 설명: 선택되기 전의 국가 Path 스타일을 초기화한다.
       */
      beforeSelectionInitStyle (tooltipEl) {
        if (this.saveSelection) {
          // Tip 숨김
          tooltipEl.style.visibility = 'hidden'

          const findItem = this.geoCountryData.find(i => i.geo === this.saveSelection.data.properties.iso_a2)
          // Tooltip 스타일 변경
          if (this.saveSelection.data.beforeStyle && findItem) {
            this.saveSelection.self.style('fill', this.saveSelection.data.beforeStyle.fill)

            // 데이터 제거
            delete this.saveSelection.data.beforeStyle
          }

          // Before click 객체 초기화
          this.saveSelection = null
        }
      },
      /**
       * 이름: tooltipGeoData
       * 설명: 마우스가 Over되어있는 전체, Inbound, Outbound 카운트를 출력한다.
       */
      tooltipGeoData () {
        return _.last(_.filter(this.geoCountryData, {geo: this.selectCode})) || {
          in: 'No data',
          out: 'No data',
          total: 'No data'
        }
      },
      /**
       * 이름: applyTooltipStyle
       * 설명: Tooltip을 화면에 출력하고 선택된 영역을 오렌지 색으로 변경한다.
       */
      applyTooltipStyle (self, data, tooltipEl) {
        this.isTooltipData = data.properties.brk_name
        tooltipEl.style.visibility = 'visible'
        // if (this.initMaximumData) {
        //   tooltipEl.style.visibility = 'hidden'
        //   this.initMaximumData = false
        // }
        // 기존 스타일 저장
        data.beforeStyle = {
          fill: self.style('fill')
        }

        // 스타일 변경
        self.style('fill', '#ffa200')
      },
      /**
       * 이름: getTooltipCoordinate
       * 설명: Tooltip 좌표를 HTML 기준으로 설정한다.
       */
      getTooltipCoordinate (event, data, tooltipEl) {
        // 현재 페이지 너비 구하기
        const pageWidth = this.$el.clientWidth
        // 툴팁 너비 구하기
        const tooltipWidth = tooltipEl.clientWidth
        // 지도 클릭
        if (event.detail !== null) {
          // 세로 위치 구하기
          tooltipEl.style.top = `${event.layerY + 35}px`
          // 마우스 위치 + 툴팁 너비가 페이지 너비를 넘어서는 경우에는 왼쪽에 툴팁 표시
          if ((event.layerX + tooltipWidth + 30) > pageWidth) {
            tooltipEl.style.left = `${event.layerX + 35}px`
          } else {
            tooltipEl.style.left = `${event.layerX + 20}px`
          }
        } else { // 테이블 클릭
          // TOP 스타일을 공통으로 적용한다.
          tooltipEl.style.top = `${data.coordinate.ey + 10}px`

          // 아이슬란드, 그린란드, 프랑스 좌표는 커스터 마이징 적용
          if (this.selectCode === 'IS') {
            tooltipEl.style.left = `${data.coordinate.cx + (this.isMaximumWidget ? 690 : 170)}px`
          } else if (this.selectCode === 'GL') {
            tooltipEl.style.left = `${data.coordinate.cx + (this.isMaximumWidget ? 675 : 250)}px`
          } else if (this.selectCode === 'FR') {
            tooltipEl.style.top = `${data.coordinate.ey + (this.isMaximumWidget ? -200 : -80)}px`
            tooltipEl.style.left = `${data.coordinate.cx + (this.isMaximumWidget ? -720 : -230)}px`
          } else {
            tooltipEl.style.left = `${data.coordinate.cx + 20}px`
          }
        }
      },
      /**
        * 이름: setColorMappingByValue
        * 설명: D3 geo path에 색상을 적용한다. 상위 트래픽 / 5 범위내에 해당하는 색상을 범위에 따라 적용한다.
        */
      setColorMappingByValue (countryPath) {
        // 국가별 정보 데이터가 없는 경우, 기본 색상으로 리턴
        if (this.geoCountryData.length === 0) {
          return '#cae3f5'
        }

        // Top50에 속해있는 국가인지 계산. 속해있지 않다면, 기본 색상으로 리턴
        const currentCode = countryPath.properties.iso_a2

        const targetIndex = this.geoCountryData.map(country => country.geo).indexOf(currentCode)

        if (targetIndex < 0) {
          return '#cae3f5'
        }

        const targetCount = this.geoCountryData[targetIndex].total

        if (!targetCount) {
          return '#cae3f5'
        }

        const biggerCount = this.geoCountryData[0]
        const divisionCount = biggerCount.total / 5

        return this.getGeoFillColorByCount(divisionCount, targetCount)
      },
      /**
       * 이름: getGeoFillColorByCount
       * 설명: 이벤트 카운터 값을 기준으로 색상을 분할한다.
       */
      getGeoFillColorByCount (divisionTraffic, targetTraffic) {
        let bgColor = ''

        if (divisionTraffic * 5 >= targetTraffic && divisionTraffic * 4 < targetTraffic) {
          bgColor = this.top5Color[0]
        } else if (divisionTraffic * 4 >= targetTraffic && divisionTraffic * 3 < targetTraffic) {
          bgColor = this.top5Color[1]
        } else if (divisionTraffic * 3 >= targetTraffic && divisionTraffic * 2 < targetTraffic) {
          bgColor = this.top5Color[2]
        } else if (divisionTraffic * 2 >= targetTraffic && divisionTraffic < targetTraffic) {
          bgColor = this.top5Color[3]
        } else {
          bgColor = this.top5Color[4]
        }

        return bgColor
      },
      // 위젯 대상 장비 필터 설정.
      async onChangeWidgetMachId ({ machId }) {
        // 위젯 옵션 변경 - 저장에 필요한 값???
        this.opts.mach_id = machId
        this.getWidgetContentsData(true, machId)
      },
      /**
       * 이름: getWidgetContentsData
       * 설명: 공격지 국가 데이터 조회를 요청한다.
       */
      async getWidgetContentsData (init = false, extraParams = null) {
        let contentsOptions = {
          widgetType: 'geo_traffic_allow'
        }

        // 장비 filter 추가
        if (this.opts.mach_id) {
          contentsOptions.machId = this.opts.mach_id
        }

        // 엑스트라 파라미터가 있는 경우 (Device Filter를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.machId) {
            contentsOptions.machId = extraParams.machId
          }
        }

        // Progress 출력 여부
        this.showProgress(true)

        // initFlag가 True면 기존 차트 데이터 초기
        if (init) {
          // 데이터 테이블 초기화
          this.geoCountryData = []
          this.selected = {}
        }

        if (this.opts.haMember) {
          contentsOptions.dataType = this.opts.haMember
        }

        // 엑스트라 파라미터가 있는 경우 (IP Type 또는 HA Mamber를 선택하여 데이터를 다시 불러와야 하는 경우)
        if (extraParams) {
          if (extraParams.haMember) {
            contentsOptions.dataType = extraParams.haMember
          }
        }

        this.$refs.worldMapComp.removeWorldmapElement()

        // API 호출
        // 허용 트래픽 조회
        const {code, result} = await this.getWidgetData(contentsOptions)

        // Series 데이터 구성
        if (code === 'ok') {
          this.restData = result

          // 전체 수로 데이터 정렬
          const sortTotal = _.sortBy(this.restData.result, 'total')

          this.geoCountryData = _.map(_.reverse(sortTotal), (item, idx) => {
            item.seq = idx
            return item
          })
        }

        if (!this.isMaximumWidget && this.isSync) {
          Bus.$emit(`${this.$options.name}_sync_maximumpopup`, {
            widgetData: this.geoCountryData
          })
        }

        // Progress 출력 여부
        this.showProgress(false)
      }
    }
  }
</script>
<style scoped>
</style>
